<template>
  <div class="cxm-Radio">
    <label class="cxm-Radio-Container">
      <div>
        <div
          class="cxm-Radio-ContainerInput"
        >
          <input
            ref="radio"
            type="radio"
            class="cxm-Radio-Input"
            :checked="shouldBeChecked"
            :val="value"
            :disabled="disable"
            @change="updateChecked"
            @blur="handleBlur"
            @focus="handleFocus"
          >
          <div
            class="cxm-RadioCustom"
            :class="classStatus"
          >
            <span />
          </div>
          <div class="cxm-Radio-Focused" />
        </div>
      </div>

      <div>
        <div
          class="cxm-Radio-LabelTitle"
          :class="classStatus"
        >
          {{ label }}
        </div>
        <div
          class="cxm-Radio-Label"
          :class="classStatus"
        >
          {{ helpText }}
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue === this.value;
    },
    classStatus() {
      return {
        disabled: this.disable,
        focused: this.focused,
      };
    },
  },
  methods: {
    updateChecked() {
      this.$emit('change', this.value);
      this.callback(this.value);
    },
    handleBlur() {
      this.focused = false;
    },
    handleFocus() {
      this.focused = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-Radio {
  position: relative;
}
.cxm-Radio-Container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cxm-Radio-ContainerInput {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  margin-right: var(--track-spacing-xs);
  &.disabled {
    cursor: not-allowed;
  }
}
.cxm-Radio-Input {
  position: absolute;
  opacity: 0;
}
.cxm-RadioCustom {
  width: 16px;
  height: 16px;
  border: 2px solid var(--track-color-bluegray-60);
  border-radius: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  &.disabled {
    border-color: var(--track-color-bluegray-40);
  }
  &:hover {
    border-color: var(--track-color-brand-primary);
    background-color: var(--track-color-brand-primary-lightest);
  }
}
.cxm-Radio input:checked ~ .cxm-RadioCustom {
  border-color: var(--track-color-brand-primary);
  &.disabled {
    border-color: var(--track-color-bluegray-40);
  }
}
.cxm-Radio input:checked ~ .cxm-RadioCustom span {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 600px;
  background-color: var(--track-color-brand-primary);
  &.disabled {
    background-color: var(--track-color-bluegray-40);
  }
}
.cxm-Radio-LabelTitle {
  color: var(--track-color-bluegray-80);
  font-family: var(--track-font-family-base);
  font-size: var(--track-font-size-xs);
  font-weight: var(--track-font-weight-regular);
  line-height: 140%;
  &.disabled {
    color: var(--track-color-bluegray-40);
  }
}
.cxm-Radio-Label {
  color: var(--track-color-bluegray-80);
  font-family: var(--track-font-family-base);
  font-size: var(--track-font-size-xxs);
  font-weight: var(--track-font-weight-medium);
  line-height: 140%;
  &.disabled {
    color: var(--track-color-bluegray-40);
  }
}
.cxm-Radio-Focused {
  background-color: var(--track-color-bluegray-20);
  border-radius: 50%;
  border: 1px solid var(--track-color-bluegray-60);
  height: 0;
  left: 50%;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.2s;
  width: 0;
  z-index: 1;

  .cxm-Radio-Input:focus ~ & {
    height: 24px;
    opacity: 1;
    width: 24px;
  }

  .cxm-Radio-Input:focus:checked ~ & {
    background-color: var(--track-color-positive-lightest);
    border-color: var(--track-color-brand-primary);
  }
}
</style>
